"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProjectByName = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@bimser/common");
const components_1 = require("@bimser/components");
const createLoadOptions = (projectName) => ({
    sorts: [],
    pagination: {
        skip: 0,
        take: 1
    },
    filters: [
        {
            Operator: components_1.BCExtremeGridEntities.GroupOperator.Or,
            Filters: [
                {
                    Column: 'name',
                    Not: false,
                    Type: components_1.BCExtremeGridEntities.FilterType.Contain,
                    Value: projectName,
                    ItemType: components_1.BCExtremeGridEntities.ItemType.String
                }
            ]
        }
    ]
});
const getProjectByName = (projectName, cache = false) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const loadOptions = createLoadOptions(projectName);
        const result = yield common_1.ServiceList.Studio.ProjectManager.GetProjectsWithLoadOptions.handleError(common_1.customErrorHandlerWithThrow).callPromise({ loadOptions }, true, { cache });
        if (!result.projects || result.projects.length === 0) {
            components_1.BCNotification.error({
                message: components_1.findMessage.get('103688').replace('{0}', projectName)
            });
            return null;
        }
        return result.projects[0];
    }
    catch (ex) {
        console.error(`An error occurred while fetching the project: ${projectName}. ${ex.message}`);
        throw ex;
    }
});
exports.getProjectByName = getProjectByName;
//# sourceMappingURL=getProjectByName.js.map